import PreferenceStatusButtons from './PreferenceStatusButtons';

const ShowPreferenceControl = ({
    status,
    onStatusChange,
    mutation,
    onRetry,
    className = '',
    variant = 'compact',
    positiveLabel,
    selectedPositiveLabel,
    negativeLabel,
}) => (
    <div className={`showPreferenceControl ${className}`}>
        <PreferenceStatusButtons
            status={status}
            onStatusChange={(nextStatus) => {
                if (!mutation?.saving) onStatusChange(nextStatus);
            }}
            variant={variant}
            positiveLabel={positiveLabel}
            selectedPositiveLabel={selectedPositiveLabel}
            negativeLabel={negativeLabel}
        />
        {mutation?.error && !mutation.saving && (
            <div className='showPreferenceError' role='alert'>
                <span>Couldn’t save · </span>
                <button type='button' onClick={onRetry}>Retry</button>
            </div>
        )}
    </div>
);

export default ShowPreferenceControl;
